import { forwardRef } from "react";
import Modal, { CommonModalProps } from "..";
import CodeBox from "../../Misc/CodeBox/code-box";
import { useTranslation } from "react-i18next";

export type ModalShowJsonOutputElementProps = {
  object: any;
};
export type ModalShowJsonOutputProps = CommonModalProps<ModalShowJsonOutputElementProps>;

const ModalShowJsonOutput = forwardRef<any, ModalShowJsonOutputProps>((props, ref) => {
  const { t } = useTranslation();

  const handleCloseClick = () => {
    props.closeModal();
  };

  return (
    <Modal title={t("modal:title.jsonOutput")} reference={ref} closeModal={handleCloseClick} width={750}>
      <CodeBox text={props.object} />
    </Modal>
  );
});

export default ModalShowJsonOutput;
